import { ApolloError } from "@apollo/client";
import { Banner, LegacyCard, EmptyState, Grid, Layout, Page, PageProps } from "@shopify/polaris";
import React from "react";
import { Loading } from "./Loading";

interface Props {
  pageProp: PageProps;
  loading?: boolean;
  tabs?: boolean;
  card?: boolean;
  error?: ApolloError;
  isEmpty?: boolean;
  IBreadCrumbs?: {
    content: string;
    url?: string;
    onAction?: () => void;
  }[];
}

export function PageLayout(props: React.PropsWithChildren<Props>) {
  // if (props.loading) {
  //   return <Loading pageProp={{ ...(props.pageProp as SkeletonPageProps) }} tabs={props.tabs} card={props.card} />;
  // }

  const EmptyRecord = () => {
    return (
      <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 6, lg: 12, xl: 12 }}>
        <LegacyCard>
          <LegacyCard.Section>
            <EmptyState
              heading="Empty records"
              image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
            >
              <p>Currently no records data about {props.pageProp.title?.toLowerCase()} yet.</p>
            </EmptyState>
          </LegacyCard.Section>
        </LegacyCard>
      </Grid.Cell>
    );
  };

  const ErrorQuery = () => {
    return (
      <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 6, lg: 12, xl: 12 }}>
        <LegacyCard>
          <LegacyCard.Section>
            <EmptyState
              heading="Oop! somthing wrong."
              image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
            >
              <p>{props.error?.networkError}</p>
            </EmptyState>
          </LegacyCard.Section>
        </LegacyCard>
      </Grid.Cell>
    );
  };

  return (
    <Page {...props.pageProp}>
      {props.error && (
        <div>
          <Banner title={"Some of your data are was wrong"} tone="critical"></Banner>
          <br />
        </div>
      )}
      <Layout>
        <Layout.Section>
          {props.loading && (
            <Loading pageProp={{ fullWidth: props.pageProp.fullWidth }} tabs={props.tabs} card={props.card} />
          )}
          <Grid>
            {props.isEmpty && <EmptyRecord />}
            {props.error && <ErrorQuery />}
          </Grid>
          {!props.tabs || !props.card ? props.children : props.loading ? <></> : props.children}
        </Layout.Section>
      </Layout>
    </Page>
  );
}
